import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/incidencias-empleados-detalles';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET incidencias Empleados Detalles
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasEmpleadosDetalles = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET incidencia Empleado Detalle
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaEmpleadoDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST incidencia Empleado Detalle
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaEmpleadoDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH incidencia Empleado Detalle
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaEmpleadoDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE incidencia Empleado Detalle
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaEmpleadoDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
